import { INetworkType } from "@/module/wallet/types";

export type AssetType = "EUSD" | "USDT";

export const BLOCKCHAIN_NETWORKS_ALIAS: Record<string, string> = {
  "EUSD-MOB": "Mobile Coin (MOB)",
  "USDT-POL": "Polygon (MATIC)",
};

export const BLOCKCHAIN_NETWORKS: { value: INetworkType; title: string }[] = [
  {
    title: "Mobile Coin (MOB)",
    value: "EUSD-MOB",
  },
  {
    title: "Polygon (MATIC)",
    value: "USDT-POL",
  },
];

export const BLOCKCHAIN_ASSEST: Array<{ title: string; value: AssetType }> = [
  {
    title: "EUSD",
    value: "EUSD",
  },
  {
    title: "USDT",
    value: "USDT",
  },
];
